import React from 'react';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';
import ExploreCard from 'Components/ExploreCard';
import { ROUTES } from 'Settings/route-strings';

const TopicCard = ({ topicSlug, topic, modelSlug }) => {
  const sceneId = typeof topic === 'object' ? topic.sceneId : topic;
  const topicId = `model.${modelSlug}.scenes.${sceneId}`;
  const graphic = require(`Static/images/topic-screenshots/${modelSlug}/${sceneId}.png`);
  return (
    <ExploreCard
      to={`${ROUTES.EXPLORE}/${modelSlug}/${topicSlug}`}
      isNew={false}
      id={modelSlug}
      type="topic"
      graphic={
        <ConnectedFormattedImage
          className="ExploreCard__screenshot"
          src={graphic}
          altId={`${topicId}.title`}
        />
      }
      title={<ConnectedFormattedMessage id={`${topicId}.title`} />}
    />
  );
};

export default TopicCard;
